module.exports = __webpack_public_path__ + "static/media/barcelona_getty_tablet.9a3ecaa3.jpg";